import { render, staticRenderFns } from "./IndicatorAgent.vue?vue&type=template&id=1983f6af&scoped=true"
import script from "./IndicatorAgent.vue?vue&type=script&lang=js"
export * from "./IndicatorAgent.vue?vue&type=script&lang=js"
import style0 from "./IndicatorAgent.vue?vue&type=style&index=0&id=1983f6af&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1983f6af",
  null
  
)

export default component.exports